/* import __COLOCATED_TEMPLATE__ from './question-creation-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import {
  ExtractionType,
  type PlaygroundQuestionGeneration,
} from 'embercom/lib/fin-playground/question-generation';

interface Signature {
  Args: {
    hasAvailableExtractions: number | undefined;
    questionGeneration: PlaygroundQuestionGeneration;
    generateQuestions: (type: ExtractionType) => void;
    isQuestionGenerationRunning: boolean;
    onShowUploadCSV: () => void;
    onAddQuestionsManually: () => void;
    canUsePlaygroundGroups?: boolean;
    openNewGroupModal?: (place: string) => void;
    selectAddQuestionDropdownOption?: (option: string) => void;
  };
}

export default class QuestionCreationEmptyState extends Component<Signature> {
  @service declare intl: IntlService;

  ExtractionType = ExtractionType;

  get addQuestionDropdownOptions() {
    let items = [];

    if (this.args.questionGeneration.isPossible) {
      items.push({
        text: this.intl.t('ai-agent.playground.add-questions-dropdown.generate-questions'),
        value: 'generate-questions',
      });
    }

    items.push(
      {
        text: this.intl.t('ai-agent.playground.add-questions-dropdown.upload-csv'),
        value: 'upload-csv',
      },
      {
        text: this.intl.t('ai-agent.playground.add-question'),
        value: 'add-question',
      },
    );

    if (this.args.canUsePlaygroundGroups) {
      let createNewGroupItem = {
        text: this.intl.t('ai-agent.playground.add-questions-dropdown.create-new-test'),
        icon: 'new',
        onSelectItem: () => {
          if (this.args.openNewGroupModal) {
            this.args.openNewGroupModal('groups-empty-state-screen');
          }
        },
      };

      return [{ items }, { items: [createNewGroupItem] }];
    } else {
      return [{ items }];
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::QuestionCreationEmptyState': typeof QuestionCreationEmptyState;
    'ai-agent/playground/question-creation-empty-state': typeof QuestionCreationEmptyState;
  }
}
